(() => {
  function initialiseAdaptiveChecklist(objRoot) {
    if (objRoot.dataset.adaptiveReady) return;
    objRoot.dataset.adaptiveReady = 'true';
    const strHandle = objRoot.dataset.adaptiveHandle || 'article';
    const strStorageKey = `lucid:article-checklist:${strHandle}:v1`;
    const arrInputs = Array.from(objRoot.querySelectorAll('[data-adaptive-check]'));
    const objCount = objRoot.querySelector('[data-adaptive-count]');
    const objTotal = objRoot.querySelector('[data-adaptive-total]');
    const objProgress = objRoot.querySelector('[data-adaptive-progress]');
    const objStatus = objRoot.querySelector('[data-adaptive-status]');
    const objReset = objRoot.querySelector('[data-adaptive-reset]');
    let boolCanSave = true;
    try {
      const arrSaved = JSON.parse(localStorage.getItem(strStorageKey) || '[]');
      if (Array.isArray(arrSaved)) arrInputs.forEach((objInput) => { objInput.checked = arrSaved.includes(objInput.dataset.adaptiveCheck); });
    } catch { boolCanSave = false; }
    function updateAdaptiveChecklist(boolPersist) {
      const arrChecked = arrInputs.filter((objInput) => objInput.checked);
      const intCount = arrChecked.length;
      const intTotal = arrInputs.length;
      objCount.textContent = String(intCount);
      objTotal.textContent = String(intTotal);
      objProgress.max = Math.max(1, intTotal);
      objProgress.value = intCount;
      objProgress.textContent = `${intCount} sur ${intTotal} terminé${intCount > 1 ? 's' : ''}`;
      objStatus.textContent = intCount === intTotal ? 'Checklist terminée.' : intCount === 0 ? 'Prêt quand vous l’êtes.' : `${intTotal - intCount} à vérifier.`;
      objReset.disabled = intCount === 0;
      objRoot.classList.toggle('ld-adaptive-complete', intTotal > 0 && intCount === intTotal);
      if (boolPersist && boolCanSave) {
        try { localStorage.setItem(strStorageKey, JSON.stringify(arrChecked.map((objInput) => objInput.dataset.adaptiveCheck))); }
        catch { boolCanSave = false; }
      }
    }
    arrInputs.forEach((objInput) => objInput.addEventListener('change', () => updateAdaptiveChecklist(true)));
    objReset.addEventListener('click', () => {
      arrInputs.forEach((objInput) => { objInput.checked = false; });
      updateAdaptiveChecklist(true);
      if (arrInputs[0]) arrInputs[0].focus({ preventScroll: true });
    });
    updateAdaptiveChecklist(false);
  }
  document.querySelectorAll('[data-adaptive-checklist]').forEach(initialiseAdaptiveChecklist);
  document.addEventListener('shopify:section:load', (objEvent) => objEvent.target.querySelectorAll('[data-adaptive-checklist]').forEach(initialiseAdaptiveChecklist));
})();
